<template>
  <div
    class="wb-grid-col-mq1-12 wb-grid-col-mq3-6 wb-grid-col-mq4-4"
    :class="{ 'owc-table-cell-author': isEditMode }"
    :data-is-in-modal="isInModal"
  >
    <ValidationBoxWrapper v-if="isEditMode">
      <slot slot="validation-box" name="validation-box" />
    </ValidationBoxWrapper>
    <div class="wb-grid-col-mq1-12">
      <div class="owc-table-cell">
        <p class="owc-table-cell__label-wrapper">
          <span class="owc-table-cell__label" v-html="label"></span>
          <wb-tooltip-host class="owc-table-cell__label-tooltip-host" v-if="hasTooltip" position="top">
            <wb-icon class="owc-table-cell__label-tooltip-icon" name="question-mark-outline"> </wb-icon>
            <wb-tooltip hidden>
              <span v-html="tooltip"></span>
            </wb-tooltip>
          </wb-tooltip-host>
        </p>
        <div class="owc-table-cell__value-wrapper">
          <div class="owc-table-cell__value owc-rte-stylings" v-html="value"></div>
          <wb-eco-label v-if="hasEfficiency" class="owc-table-cell__value-efficiency" :rating="efficiency">
          </wb-eco-label>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import { TableCellComputed, TableCellData, TableCellMethods, TableCellProps } from './TableCell';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import { mountFootnotes } from '@owc-utils/Footnotes/FootnotesHelper';
import { isMobileLayout } from './TableUtils';

export default ComponentInitializeDispatcher.extend<
  TableCellData,
  TableCellMethods,
  TableCellComputed,
  TableCellProps
>({
  name: 'owc-table-cell',
  components: {
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent],
  computed: {
    label: function() {
      return this.componentData?.label;
    },
    value: function() {
      return this.componentData?.value;
    },
    tooltip: function() {
      return this.componentData?.tooltip;
    },
    hasTooltip: function() {
      return Boolean(this.componentData?.tooltip);
    },
    efficiency: function() {
      return this.componentData?.efficiency;
    },
    hasEfficiency: function() {
      return Boolean(this.componentData?.efficiency);
    },
    isInModal: function() {
      return Boolean(this.componentData?.isInModal && isMobileLayout);
    },
  },
  watch: {
    isInModal: {
      handler(newValue: boolean, oldValue: boolean) {
        if (newValue !== oldValue && oldValue !== undefined) {
          if (this.$el.querySelector('[data-footnote-id]')) {
            mountFootnotes(this, newValue);
          }
        }
      },
    },
  },
});
</script>

<style lang="scss">
@import '@owc-styles/utils/rtl-utils';
@import '@owc-styles/utils/rte';

.owc-table-cell-author {
  width: 100%;
}
.owc-table-cell {
  padding: 12px 0 12px var(--wb-spacing-s);

  @include rtl-rule(&, false) {
    padding-right: var(--wb-spacing-s);
    padding-left: initial;
  }

  border-bottom: 1px solid var(--wb-grey-85);

  color: var(--wb-grey-20);

  &__label {
    @include wb-type-copy;
    color: var(--wb-grey-60);

    &-tooltip-icon {
      width: 24px;
      height: 24px;

      color: var(--wb-grey-60);
    }
  }
  &__label-wrapper {
    display: flex;
    align-items: center;
  }
  &__value {
    @include wb-type-copy-strong;
  }
  &__label,
  &__value {
    // Since label is inserted via v-html, it can happen that author provides
    // the label wrapped inside a paragraph (eg. if footnote exists)
    p {
      display: inline-block;
    }
  }
  &__value-efficiency {
    display: inline-flex;
    margin-left: var(--wb-spacing-xxs);

    @include rtl-rule(&, false) {
      margin-right: var(--wb-spacing-xxs);
      margin-left: initial;
    }
  }
}
</style>
